<template>
    <div id="customers">
        <!-- Messages -->
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <Filters></Filters>

        <!-- Data table -->
        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="customer in customers"
                    :key="customer.identity"
                    :object="customer"
                    :title="customer.company_name"
                    :title_link="{name: 'provider_customer', params: {customer_identity: customer.identity}}"
                    :sub_title="data_card_sub_title(customer)"
                    :color="data_card_color(customer)"
                    :date="human_datetime(customer.created_at)"
                    :is_show_column="true"
                    :keys="['username','password','company_name','email','authentication_token', 'contracts','fax']"
                    :i_18n_key="'customers'"
                >
                    <pre slot="authentication_token" class="token z-depth-1">{{ customer.authentication_token }}</pre>
                    <span slot="contracts" v-if="customer.contracts">
                        <router-link class="item" v-for="(contract, index) in customer.contracts"
                            :key="contract.identity"
                            :to="{
                                name: 'provider_contract',
                                params: {
                                    customer_identity: customer.identity,
                                    contract_identity: contract.identity
                                }
                            }">
                            {{ index + 1 }}. {{ contract.name }}
                            &nbsp;
                        </router-link>
                    </span>
                    <div slot="buttons">
                        <a class="ui basic orange button" @click="proxy_login(customer)">
                            {{ $t('ui.pages.customers.proxy_login') }}
                        </a>
                        <!-- <a href="#" @click.prevent="delete_customer" class="ui basic red button">{{ $t('ui.general.delete') }}</a> -->
                        <button class="ui basic button" @click="toggle_is_banned(customer)"
                            :class="[
                                customer.is_banned ? 'positive' : 'negative',
                                customer.is_loading ? 'loading' : ''
                            ]">
                            <span v-if="customer.is_banned">{{ $t('ui.pages.customers.unbanned') }}</span>
                            <span v-else>{{ $t('ui.pages.customers.banned') }}</span>
                        </button>
                    </div>
                </DataCard>

                <div v-if="!is_loading && customers.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead class="center aligned">
                    <!-- Column names -->
                    <tr>
                        <th>{{ $t('models.attributes.customers.username') }}</th>
                        <th>{{ $t('models.attributes.customers.password') }}</th>
                        <th>{{ $t('models.attributes.customers.company_name') }}</th>
                        <th>{{ $t('models.attributes.customers.email') }}</th>
                        <th>{{ $t('models.attributes.customers.phone') }}</th>
                        <th>{{ $t('models.attributes.customers.authentication_token') }}</th>
                        <th>所屬站點</th>
                        <th>{{ $t('ui.pages.customers.contracts') }}</th>
                        <th>{{ $t('models.attributes.customers.fax') }}</th>
                        <th>{{ $t('ui.pages.customers.banned') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <!-- Data loader -->
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="8">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <!-- Data contents -->
                <tbody v-else class="center aligned">
                    <Row v-for="customer in customers"
                        :key="customer.identity"
                        :customer="customer">
                    </Row>
                    <tr v-if="customers.length <= 0" class="center aligned">
                        <td colspan="8">
                            <h5>
                                {{ $t('ui.general.no_data') }}
                            </h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                :total_pages="Number(pagination.total_pages)"
                :current_page="Number(pagination.current_page)"
                :disabled="is_loading">
            </Paginator>
        </div>
    </div>
</template>

<script>
import Row from "./row.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'
import Filters from "./filter/main.vue"

export default {
    name: "CustomersIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
        }
    },
    computed: {
        style: (instance) => instance.$store.state.style,
        current_store: (instance) => instance.$store.state.provider.customers_module,
        pagination() {
            return this.current_store.pagination
        },
        filter() {
            return this.current_store.filter
        },
        customers() {
            return this.current_store.customers
        },
        current_node_identity() {
            return this.node_index > 0 ? ENV.VUE_APP_SECOND_NODE_IDENTITY:ENV.VUE_APP_FIRST_NODE_IDENTITY
        },
        login_url() {
            console.log(this.$store.state.settings.login_url)
            if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                // 使用 environment variables 內的 LICENSE_KEY 為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': window.LICENSE_KEY
                    },
                    "?captcha=" + this.need_captcha
                )
            } else if (ENV.NODE_ENV == 'development') {
                // 使用 env.js 內的 LICENSE_KEY 為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': this.current_node_identity
                    },
                    "?captcha=" + this.need_captcha
                )
            } else {
                // 使用HOSTNAME為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': ""
                    },
                    "?captcha=false"
                )
            }
        },
    },
    created() {
    },
    mounted() {
        this.init()
        this.pagination.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('provider/customers_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/customers_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/customers_module/fetch_customers')
                await new Promise(resolve => {
                    this.$noty.information(
                        this.$t("ui.page_titles.provider_customers") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                console.log("init error: ")
                console.log(e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name',{
                        name: this.$t('models.customers'),
                        reason: e
                    })
                )
            } finally {
                this.is_initialized = true
                this.is_loading = false
            }
        },
        customers_filter() {
            console.log('customers_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/customers_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        data_card_sub_title(customer) {
            return (customer.is_banned)
                ? `<i class="remove icon"></i> ${this.$t('ui.pages.customers.banned')}`
                : `<i class="check icon"></i> ${this.$t('ui.pages.customers.normal')}`
        },
        data_card_color(customer) {
            return (customer.is_banned) ? 'red' : 'green'
        },
        associate_to_node(customer) {
            customer.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_customer_associate_to_node).parse({
                "customer_identity": customer.identity,
            })

            axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                        // this.$noty.success('更新客戶成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.customers')
                            })
                        )
                    } else {
                        // this.$noty.error('更新客戶失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.customers'),
                            })
                        )
                    }
                    customer.is_loading = false
                })
                .catch(error => {
                    console.log(error.response)
                    customer.is_loading = false
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.customers')
                        })
                    )
                })
                .finally(() => {
                    this.$forceUpdate()
                })
        },
        proxy_login(customer) {
            var params = {
                "username": customer.username,
                "password": customer.password,
                "role": "customer"
            }

            axios.post(this.login_url, params,  {headers: { Hostname: window.location.hostname }})
            .then(response => {
                if (response.data.status == 'success') {
                    localStorage.setItem("customer_authentication_token", response.data.token)
                    localStorage.setItem("customer_expired_at", this.$moment.utc(this.$moment().add(this.$store.state.global_setting.login_expiration_period, 'second')).format())
                    window.open('/customer', 'new')
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        toggle_is_banned(customer) {
            customer.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_customer_update).parse({
                "customer_identity": customer.identity,
            })

            axios.post(url, {is_banned: !customer.is_banned}, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        customer.is_banned = response.data.customer.is_banned
                        this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                        // this.$noty.success('更新客戶成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.customers')
                            })
                        )
                    } else {
                        // this.$noty.error('更新客戶失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.customers'),
                            })
                        )
                    }
                    customer.is_loading = false
                })
                .catch(error => {
                    console.log(error.response)
                    customer.is_loading = false
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.customers')
                        })
                    )
                })
                .finally(() => {
                    this.$forceUpdate()
                })
        },
        init_filter_columns() {
            this.$store.commit('provider/customers_module/init_filter_columns')
            // $("#customers .ui.dropdown").dropdown('clear')
        },
    },
    components: {
        Row,
        Paginator,
        ErrorMessages,
        DataCard,
        Filters,
    }
}
</script>

<style scoped>
    pre.token {
        background: #ffffed;
        padding: 10px;
        overflow: auto;
        border: 1px solid #EEE;
        border-radius: 3px;
    }
</style>
